import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { parse, format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

function PremioItem({ row, onSelect, isSelected }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const premio = row.original;

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const handleCheckboxChange = () => onSelect(premio.id);

    const { key, ...rowProps } = row.getRowProps();

    return (
        <tr {...rowProps} className="bmember-b bmember-stroke border-b border-gray-200">
            <td className="text-left xl:p-4 text-sm font-medium">
                <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={handleCheckboxChange}
                />
            </td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium uppercase text-sm">{premio.nome}<br/> {premio.cpf}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{premio.premio}<br/> {premio.pontos}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{premio.voltagem}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{premio.status}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{premio.endereco}<br/>{premio.cidade} - {premio.estado}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{premio.razao}<br/>({premio.cnpj})</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{premio.email}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">
                {new Date(premio.criado).toLocaleDateString('pt-BR')}
            </td>
            <td className="p-2 pr-0 text-left 1xl:p-4 xl:pr-0 text-xs 1xl:text-sm">
                <div className="flex items-center gap-2">
                    <Link to={`/manager/premios/editar/${premio.id}`} className="bg-primary w-8 h-8 rounded-full flex items-center justify-center duration-200 ease-in-out hover:bg-opacity-80">
                        <FontAwesomeIcon icon={faEdit} className="text-white ml-[1px] mb-[1px]" />
                    </Link>
                </div>
            </td>
        </tr>
    );
}

export default PremioItem;
